<template>

  <div class="min-h-screen bg-slate-50">

    <!-- Sidebar + contenido -->

    <div class="flex">

      <!-- Overlay móvil -->
      <div
        v-if="sidebarOpen"
        class="fixed inset-0 z-20 bg-black/50 lg:hidden"
        @click="sidebarOpen = false"
      ></div>

      <!-- Sidebar -->
      <aside
        class="fixed lg:static inset-y-0 left-0 z-30 w-64 min-h-screen bg-gradient-to-b from-emerald-900 to-emerald-800 shadow-2xl flex flex-col transition-transform duration-300"
        :class="sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'"
      >

        <!-- Logo -->

        <div class="px-6 py-6 border-b border-emerald-700 flex items-center justify-between">

          <router-link to="/" class="flex items-center gap-3 group">

            <div class="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">

              <i class="fa-solid fa-laptop-code text-white text-lg"></i>

            </div>

            <div>

              <p class="text-white font-bold text-lg leading-none">MADAV<span class="text-emerald-300"> Solutions</span></p>

              <p class="text-emerald-300 text-xs">Panel Admin</p>

            </div>

          </router-link>

          <!-- Cerrar sidebar en móvil -->
          <button class="lg:hidden text-emerald-300 hover:text-white p-1" @click="sidebarOpen = false">
            <i class="fa-solid fa-xmark text-lg"></i>
          </button>

        </div>



        <!-- Navegación -->

        <nav class="flex-1 px-4 py-6 space-y-1">

          <p class="text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-3 px-2">Catálogos</p>



          <router-link

            to="/admin/sistemas"

            class="flex items-center gap-3 px-4 py-3 rounded-xl text-emerald-200 hover:bg-white/10 hover:text-white transition-all duration-200 group"

            active-class="bg-white/20 text-white font-semibold shadow"

            @click.native="sidebarOpen = false"

          >

            <i class="fa-solid fa-cubes text-sm w-4"></i>

            <span>Sistemas</span>

          </router-link>



          <router-link

            to="/admin/planes"

            class="flex items-center gap-3 px-4 py-3 rounded-xl text-emerald-200 hover:bg-white/10 hover:text-white transition-all duration-200"

            active-class="bg-white/20 text-white font-semibold shadow"

            @click.native="sidebarOpen = false"

          >

            <i class="fa-solid fa-box-open text-sm w-4"></i>

            <span>Planes</span>

          </router-link>



          <router-link

            to="/admin/caracteristicas"

            class="flex items-center gap-3 px-4 py-3 rounded-xl text-emerald-200 hover:bg-white/10 hover:text-white transition-all duration-200"

            active-class="bg-white/20 text-white font-semibold shadow"

            @click.native="sidebarOpen = false"

          >

            <i class="fa-solid fa-list-check text-sm w-4"></i>

            <span>Características</span>

          </router-link>

          <!-- ── Administración ─────────────────────────── -->
          <div class="pt-4 pb-1">
            <p class="text-emerald-400 text-xs font-semibold uppercase tracking-widest px-2">Administración</p>
          </div>

          <router-link

            to="/admin/clientes"

            class="flex items-center gap-3 px-4 py-3 rounded-xl text-emerald-200 hover:bg-white/10 hover:text-white transition-all duration-200"

            active-class="bg-white/20 text-white font-semibold shadow"

            @click.native="sidebarOpen = false"

          >

            <i class="fa-solid fa-users text-sm w-4"></i>

            <span>Clientes</span>

          </router-link>

          <router-link

            to="/admin/sistemas-clientes"

            class="flex items-center gap-3 px-4 py-3 rounded-xl text-emerald-200 hover:bg-white/10 hover:text-white transition-all duration-200"

            active-class="bg-white/20 text-white font-semibold shadow"

            @click.native="sidebarOpen = false"

          >

            <i class="fa-solid fa-laptop-code text-sm w-4"></i>

            <span>Sistemas</span>

          </router-link>

          <router-link

            to="/admin/promociones"

            class="flex items-center gap-3 px-4 py-3 rounded-xl text-emerald-200 hover:bg-white/10 hover:text-white transition-all duration-200"

            active-class="bg-white/20 text-white font-semibold shadow"

            @click.native="sidebarOpen = false"

          >

            <i class="fa-solid fa-tag text-sm w-4"></i>

            <span>Promociones</span>

          </router-link>

        </nav>



        <!-- Footer sidebar -->

        <div class="px-6 py-4 border-t border-emerald-700">

          <router-link to="/" class="flex items-center gap-2 text-emerald-300 hover:text-white text-sm transition-colors duration-200">

            <i class="fa-solid fa-arrow-left text-xs"></i>

            <span>Volver al sitio</span>

          </router-link>

        </div>

      </aside>



      <!-- Contenido principal -->

      <main class="flex-1 flex flex-col min-h-screen lg:ml-0 w-full">

        <!-- Topbar -->

        <header class="bg-white shadow-sm border-b border-slate-200 px-4 md:px-8 py-4 flex items-center justify-between">

          <!-- Botón hamburguesa (solo móvil) -->
          <button
            class="lg:hidden mr-3 text-slate-500 hover:text-emerald-600 transition-colors"
            @click="sidebarOpen = true"
          >
            <i class="fa-solid fa-bars text-xl"></i>
          </button>

          <h1 class="text-slate-700 font-semibold text-base md:text-lg">

            <i class="fa-solid fa-shield-halved text-emerald-500 mr-2"></i>

            Panel de Administración

          </h1>

          <div class="flex items-center gap-3 text-sm text-slate-500">

            <i class="fa-solid fa-database text-emerald-400"></i>

            <span class="hidden sm:inline">SistemasMav</span>

            <button
              @click="cerrarSesion"
              class="ml-2 flex items-center gap-1 text-slate-400 hover:text-red-500 transition"
              title="Cerrar sesión"
            >
              <i class="fa-solid fa-right-from-bracket"></i>
              <span class="hidden sm:inline">Salir</span>
            </button>

          </div>

        </header>



        <!-- Vista hija -->

        <div class="flex-1 p-4 md:p-8">

          <router-view />

        </div>

      </main>

    </div>

  </div>

</template>



<script>

export default {

  name: 'AdminLayout',

  data () {

    return {

      sidebarOpen: false

    }

  },

  methods: {

    cerrarSesion () {

      this.$store.dispatch('cerrarSesion')

      this.$router.push({ name: 'Login' })

    }

  }

}

</script>



